import React from 'react';
import { Edit, Layers, Trash2 } from 'lucide-react';

const RSVP_STATUS_META = {
  attending: {
    label: "Attending",
    className: "bg-emerald-50 text-emerald-700",
  },
  accepted: {
    label: "Attending",
    className: "bg-emerald-50 text-emerald-700",
  },
  yes: {
    label: "Attending",
    className: "bg-emerald-50 text-emerald-700",
  },
  not_attending: {
    label: "Not attending",
    className: "bg-rose-50 text-rose-600",
  },
  declined: {
    label: "Not attending",
    className: "bg-rose-50 text-rose-600",
  },
  no: {
    label: "Not attending",
    className: "bg-rose-50 text-rose-600",
  },
  pending: {
    label: "Pending",
    className: "bg-gray-100 text-gray-500",
  },
};

const normalizeStatus = (status) => String(status || "pending").trim().toLowerCase();

const getRsvpMeta = (status) =>
  RSVP_STATUS_META[normalizeStatus(status)] || {
    label: String(status || "Pending"),
    className: "bg-gray-100 text-gray-500",
  };

const hasResponseDetails = (guest) =>
  normalizeStatus(guest.rsvp_status) !== "pending" ||
  Boolean(guest.rsvp_message) ||
  Boolean(guest.rsvp_allergies);

export const GuestRow = ({ guest, modified, onEdit, onFineTune, onDelete, onTagClick }) => {
  const rsvpMeta = getRsvpMeta(guest.rsvp_status);
  const adults = Number(guest.rsvp_adult_count || 0);
  const kids = Number(guest.rsvp_kids_count || 0);
  const isAttending = ["attending", "accepted", "yes"].includes(normalizeStatus(guest.rsvp_status));

  return (
    <tr className={`hover:bg-[#fff4fb]/40 transition-colors group ${modified ? "bg-yellow-50/30" : ""}`}>
      <td className="px-8 py-6">
        <div className="font-black text-gray-900">{guest.guest.guest_name}</div>
        <div className="text-[11px] font-bold text-gray-400 uppercase tracking-tighter">{guest.guest.email_id}</div>
        {guest.invite_sent ? (
          <p className="mt-2 text-[10px] font-black uppercase tracking-[0.16em] text-emerald-600">
            Invite sent
          </p>
        ) : (
          <p className="mt-2 text-[10px] font-black uppercase tracking-[0.16em] text-gray-400">
            Not sent yet
          </p>
        )}
      </td>
      <td className="px-8 py-6 align-top">
        <span className={`inline-flex rounded-full px-3 py-1.5 text-[10px] font-black uppercase tracking-wide ${rsvpMeta.className}`}>
          {rsvpMeta.label}
        </span>
        {hasResponseDetails(guest) ? (
          <div className="mt-2 max-w-[260px] space-y-1 text-[11px] font-semibold leading-5 text-gray-500">
            {isAttending && (guest.rsvp_adult_count || guest.rsvp_kids_count) ? (
              <p>
                {adults || 0} adult{adults === 1 ? "" : "s"}
                {kids ? `, ${kids} kid${kids === 1 ? "" : "s"}` : ""}
              </p>
            ) : null}
            {guest.rsvp_allergies ? <p>Dietary: {guest.rsvp_allergies}</p> : null}
            {guest.rsvp_message ? <p className="italic text-gray-600">"{guest.rsvp_message}"</p> : null}
          </div>
        ) : (
          <p className="mt-2 text-[10px] font-bold text-gray-400">Awaiting response</p>
        )}
      </td>
      <td className="px-8 py-6">
        <div className="flex flex-wrap gap-2">
          {guest.group_tags?.length > 0 ? (
            guest.group_tags.map((tag) => (
              <span
                key={tag.id}
                className="px-3 py-1 bg-purple-100 text-purple-600 rounded-full text-[10px] font-bold cursor-pointer"
                onClick={() => onTagClick(tag)}
              >
                #{tag.name}
              </span>
            ))
          ) : (
            <span className="px-4 py-1.5 bg-gray-100 text-gray-400 rounded-full text-[10px] font-black uppercase">General</span>
          )}
        </div>
      </td>
      <td className="px-8 py-6">
        {(guest.media_permissions?.length || guest.subevent_links?.length) ? (
          <span className="rounded-full bg-purple-50 px-3 py-1.5 text-[10px] font-black uppercase tracking-wide text-purple-600">
            Personalized
          </span>
        ) : (
          <span className="rounded-full bg-emerald-50 px-3 py-1.5 text-[10px] font-black uppercase tracking-wide text-emerald-600">
            Standard invite
          </span>
        )}
        {(guest.media_permissions?.length || 0) > 0 && (
          <p className="mt-2 text-[10px] font-bold text-gray-400">
            {guest.media_permissions.length} private file{guest.media_permissions.length === 1 ? "" : "s"}
          </p>
        )}
      </td>
      <td className="px-8 py-5 text-right flex justify-end gap-3">
        <button onClick={() => onEdit(guest)} className="p-2 text-gray-400 hover:text-[#ff0099] rounded-xl"><Edit size={18} /></button>
        <button onClick={() => onFineTune(guest)} className="p-2 text-gray-400 hover:text-purple-600 rounded-xl"><Layers size={18} /></button>
        <button onClick={() => onDelete(guest.id)} className="p-2 text-gray-400 hover:text-red-500 rounded-xl"><Trash2 size={18} /></button>
      </td>
    </tr>
  );
};
